/*
|--------------------------------------------------------------------------
| Core
|--------------------------------------------------------------------------
|
| Entry point: imports CSS, Alpine.js, LazyLoad, and custom scripts.
| No CDN dependencies — everything is bundled here by Vite.
|
*/

import '../css/page.css'
import Alpine from 'alpinejs'
import LazyLoad from 'vanilla-lazyload'
import './script.js'

// Initialize Alpine.js
window.Alpine = Alpine
Alpine.start()

// Initialize lazy-loading for images with class="lazy"
new LazyLoad({ elements_selector: '.lazy' })
